import { Box, FormControl, InputLabel, MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import type React from 'react';

import styled from 'styled-components';
import { graphKindConfig } from '@/components/phasesCurve/phaseCurve.config.ts';
import { type Theme, useTheme } from '@mui/material/styles';
import type { GraphKinds } from '@/components/phasesCurve/interfaces.ts';
import { observer } from 'mobx-react';

interface IProps {
  isExpanded: boolean;
  graphKind: GraphKinds;
  handleKindChange: (event: SelectChangeEvent) => void;
}

export const GraphHeader = observer(({ isExpanded, graphKind, handleKindChange }: IProps): React.ReactElement => {
  const theme: Theme = useTheme();
  const selectStyles = {
    width: 220,
    marginRight: '0.2em',
    ...(theme.mode === 'dark'
      ? {
          '.MuiSvgIcon-root ': {
            fill: theme.font
          },
          border: `1px solid  ${theme.font}`,
          color: theme.font
        }
      : {})
  };

  return isExpanded ? (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <ControlContainer>
          <InputLabel id="graph-kind-select-label">Phase vs</InputLabel>
          <Select
            sx={selectStyles}
            labelId="graph-kind-select-label-select-label"
            id="graph-kind-select"
            data-testid="graphKindSelectTuneBtn"
            value={graphKind}
            label="Phase vs"
            onChange={handleKindChange}
          >
            {Object.entries(graphKindConfig).map(([key, value]) => (
              <MenuItem key={key} value={key} data-testid={'selectPhaseOption' + key}>
                {value.label}
              </MenuItem>
            ))}
          </Select>
        </ControlContainer>
      </FormControl>
    </Box>
  ) : (
    <BoxHeader>Phase Selection by {graphKindConfig[graphKind].unitsLabel}</BoxHeader>
  );
});

const ControlContainer = styled.div`
  padding: 0 0 0.6em 0;
  position: relative;
  margin-top: 0.6em;
`;

const BoxHeader = styled.h3`
  margin: 1.3em 0 0.7em 0.5em;
  font-size: 1.1em;
  font-weight: normal;
  color: ${({ theme }): string => theme.palette.secondary.light};

  @media (max-width: 100rem) {
    margin: 0.7em 0 0.7em 0.5em;
  }
`;
